import styled from 'styled-components';

export const Wrapper = styled.div`
/* background-color:#E5D8DA; */
padding: 1rem;
width: fit-content;
position:absolute;
top:0;
left:0;

&:hover{
  cursor:pointer;
}

`;

export const BackButtonIcon = styled.img`
width: 2rem;
`